import { useField } from 'formik';

import { TextField } from '@zendesk/forethought-elements';
import FormInputFormat from './FormInputFormat';
import ContextVariableAutocomplete from 'src/components/context-variable-autocomplete';

const KnowledgeTextField = ({
  allowAddingContextVariables = false,
  description,
  inputDescription,
  label,
  multiline,
  name,
  placeholder,
  shouldUseContextVariableAutocomplete = false,
}: {
  allowAddingContextVariables?: boolean;
  description: string;
  inputDescription?: string;
  label: React.ReactNode;
  multiline?: boolean;
  name: string;
  placeholder: string;
  shouldUseContextVariableAutocomplete?: boolean;
}) => {
  const [{ value }, meta, { setTouched, setValue }] = useField<string>({
    name,
  });

  const Component = shouldUseContextVariableAutocomplete
    ? ContextVariableAutocomplete
    : TextField;

  return (
    <FormInputFormat description={description} label={label}>
      <Component
        aria-label={name}
        description={inputDescription}
        error={meta.touched && meta.error}
        multiline={multiline}
        name={name}
        onChange={e => {
          const value = typeof e === 'string' ? e : e.target.value;
          setValue(value);
        }}
        onFocus={() => setTouched(true)}
        placeholder={placeholder}
        rows={multiline ? 5 : undefined}
        value={value}
        {...(shouldUseContextVariableAutocomplete && {
          isAddingContextVariablesDisabled: !allowAddingContextVariables,
        })}
      />
    </FormInputFormat>
  );
};

export default KnowledgeTextField;
